module.exports = {
    en: {
        submitForm: {
            name1: 'Fill Form',
            name2: 'Check The Status',
            submit: 'Submit',
            iagree: 'I agree with',
            terms: 'Terms and Conditions',
            clear: 'clear',
            passport: 'Passport Photo',
            ticket: 'Ticket Photo',
            other: 'Other documents',
            signatureTitle: 'Electronic signature:',
            signatureText: 'Please sign the electronic signature.',
            firstname: 'First Name',
            lastname: 'Last Name',
            phone: 'Phone',
            email: 'Email',
            city: 'City',
            address: 'Address',
            problem: 'Select Problem',
            number: 'Flight Number',
            select: 'Select',
            desc: 'Discribe the problem',
            contacttitle: "Contact Details",
            searchDesc: 'Application number (Application number sent to the email address specified in your application)',
            searchValue: 'Enter Aplication number',
            problemData: {
                1:'Flight Delay',
                2:'Flight Cancel',
                3:'OverBooked Flight',
                4:'Missed Connection',
                5:'lost Luggage'
            },
            selectData: {
                1:'I have never started process by myself\nor other claim company',
                2:'I have already tried to get compensation'
            },
            formmessage: 'Fill in all fields'
        }
    },
    ka: {
        submitForm: {
            name1: 'შეავსე ფორმა',
            name2: 'შეამოწმე სტატუსი',
            submit: 'გაგზავნა',
            iagree: 'მე ვეთანხმები',
            terms: 'წესები და პირობები',
            clear: 'გასუფთავება',
            passport: 'პასპორტის ფოტო',
            ticket: 'ბილეთის ფოტო',
            other: 'სხვა ფოტო',
            signatureTitle: 'ელ. ხელმოწერა:',
            signatureText: 'გთხოვთ მოაწეროთ ხელი.',
            firstname: 'სახელი',
            lastname: 'გვარი',
            phone: 'მობილური',
            email: 'ელ-ფოსტა',
            city: 'ქალაქი',
            address: 'მისამართი',
            problem: 'აირჩიეთ პრობლემა',
            number: 'რეისის ნომერი',
            select: 'შემთხვევა',
            desc: 'აღწერეთ პრობლემა',
            contacttitle: 'კონტაქტი',
            searchDesc: 'განაცხადის ნომერი (აპლიკაციის ნომერი იგზავნება თქვენს განაცხადში მითითებულ ელ.ფოსტის მისამართზე)',
            searchValue: 'შეიყვანეთ განცხადების ნომერი',
            problemData: {
                1:'ფრენის დაგვიანება',
                2:'ფრენის გაუქმება',
                3:'გადაჯავშნილი ფრენა',
                4:'გამოტოვებული კავშირი',
                5:'დაკარგული ბარგი'
            },
            selectData: {
                1:'არასდროს დამიწყია პროცესი ჩემით ან სხვა კომპანიის საშუალებით',
                2:'უკვე ვცადე კომპენსაციის მიღება'
            },
            formmessage: 'შეავსეთ ყველა ველი'
        }
    }
}